import React from 'react';
import { Navigate } from 'react-router';
import Base from '../Base';
import { Header } from '../Header';
import { Footer } from '../Footer';
import NumberFormat from 'react-number-format';

export default class SalaryMonthSetting extends Base {
    constructor(props) {
        super(props);
        this.state = {
            id: props.Id,
            data: null,
            loading: true
        };
    }
    componentDidMount() {
        this.httpPost("api/v1/salarymonthsetting/get", {
            id: this.getCurrentFormId(),
        })
        .then(data => {
            if (data.status === -1) window.location.href = "/login";
            if (data.status === 1) {
                this.setState({
                    data: data,
                    loading: false
                })
            }
            else {
                this.showErorrMessage(data.message);
                this.setState({
                    loading: false
                });
            }
        });
    }
    save(e) {    
        e.preventDefault();
        this.httpPost("api/v1/salarymonthsetting/save", {
            id: this.getCurrentFormId(),
            year: parseInt(this.state.data.year),
            record: this.state.data.record,
        })
        .then(data => {
            if (data.status === -1) window.location.href = "/login";
            if (data.status === 1) {
                this.showSuccessMessage("اطلاعات با موفقیت ذخیره شد");
                this.setState({
                    redirect: '/salarymonthsetting'
                })
            }
            else {
                this.showErorrMessage(data.message);
                this.setState({
                    loading: false
                });
            }
        });
    }
    getYearList() {
        var list = [];
        for (var i = this.state.data.currentShamsiYear; i >= this.state.data.currentShamsiYear-40; i--) list.push(i);
        return list;
    }
    setField(id, field, value) {
        this.state.data.record.forEach(f => {
            if (f.id === id) f[field] = value;
        });
    }
    getMonthName(month) {
        if (month === 1) return "فروردین";
        if (month === 2) return "اردیبهشت";
        if (month === 3) return "خرداد";
        if (month === 4) return "تیر";
        if (month === 5) return "مرداد";
        if (month === 6) return "شهریور";
        if (month === 7) return "مهر";
        if (month === 8) return "آبان";
        if (month === 9) return "آذر";
        if (month === 10) return "دی";
        if (month === 11) return "بهمن";
        if (month === 12) return "اسفند";
        return month;
    }
    renderForm() {
        return<div className="nk-content ">
                    <div className="container-fluid">
                        <div className="nk-content-inner">
                            <div className="nk-content-body">
                                <div className="components-preview wide-md mx-auto">
                                    <div className="nk-block-head nk-block-head-lg wide-sm">
                                        <div className="nk-block-head-content">
                                            <div className="nk-block-head-sub">
                                        <a className="back-to" to="/salarymonthsetting/"><em className="icon ni ni-arrow-left"></em><span>فهرست ساعات موظفی ماهانه</span></a>
                                             </div>
                                        </div>
                                    </div>
									<div className="nk-block nk-block-lg">
                                        <div className="card card-bordered">
                                            <div className="card-inner">
                                                <div className="card-head">
                                                    <h5 className="card-title">اطلاعات ساعات موظفی</h5>
                                                </div>
                                                <form method="post" onSubmit={e=>this.save(e)} className="row g-4">
                                                    <div className="col-lg-12">
                                                        <div className="form-group">
                                                            <label className="form-label">سال</label>
                                                    <div className="form-control-wrap">
                                                        <select className="form-control text-center" type="text" defaultValue={this.state.data.year} onChange={e => this.state.data.year = parseInt(e.target.value)}>
                                                                    {this.getYearList().map(p => <option value={p}>{p}</option>)}
                                                                </select>
                                                            </div>
                                                        </div>
                                            </div>
                                            {this.state.data.record.map(rec=>
                                                    <div className="col-lg-3">
                                                        <div className="form-group">
                                                            <label className="form-label">ساعت موظفی {this.getMonthName(rec.month)} ماه</label>
                                                    <div className="form-control-wrap">
                                                                <NumberFormat value={rec.hour} onChange={e => this.setField(rec.id, 'hour', this.isBlank(e.target.value.replace(/,/g, '')) ? 0 : parseInt(e.target.value.replace(/,/g, '')))} thousandSeparator={true} prefix={''} className='form-control text-center' />
                                                            </div>
                                                        </div>
                                                    </div>
                                            )}
                                                    <div className="col-lg-12">
                                                        <div className="form-group">
                                                            <button type="submit" className="btn btn-lg btn-primary">ذخیره</button>
                                                        </div>
                                                    </div>
                                                </form>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
    }
    render() {
        if (!this.isBlank(this.state.redirect)) return <Navigate to={this.state.redirect} />

        let contents = this.state.loading ? this.renderLoading() :
            [
                this.state.lockScreen === 1 && this.lockScreen(),
                <Header data={this.state.data} />,
                <div className="nk-content ">
                    <div className="container-fluid">
                        <div className="nk-content-inner">
                            {this.renderForm()}
                        </div>
                    </div>
                </div>,
                <Footer />
            ];

        return contents;
    }
}